
import Article from "./Article"
import AppButton from "./AppButton"

export default {
  components: {
    Article,
    AppButton
  },
  props: {
    heading: {
      type: String,
      default: null
    },
    dropdownContent: {
      type: Object,
      default: () => {}
    },
    fullScreenStyle: {
      type: Object,
      default: () => {}
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    hideCloseIcon: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    closeButtonProps: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDropdown: false
    }
  },
  computed: {
    hasDropdown() {
      return this.$slots.dropdown || this.dropdownContent
    },
    ifAriaExpanded() {
      return this.hasDropdown ? "aria-expanded" : null
    },
    ifAriaHaspopup() {
      return this.hasDropdown ? "aria-haspopup" : null
    }
  },
  methods: {
    cmsBlockToProps: props => props,
    closeBanner() {
      this.$emit("handleCloseBanner")
    }
  }
}
